const IpGuide = class{
  constructor() {
    this.$parent = document.querySelector('.as-ip-guide-bar')

    // 源数据
    this.$zoneData = document.querySelector('.as-zones-data')
    this.$regionData = document.querySelector('.as-regions-data')
    this.$localesData = document.querySelector('.as-selector-config-data')
    this.$settingsData = document.querySelector('.as-customize-app-settings-data')

    if (!this.$parent || !this.$regionData) return

    this.$data = {}
    this.$settings = {}
    this.$recommandRegionData = {}

    this.$host =  window.location.host
    this.$path = window.location.pathname
    this.$closeBarCookie = 'closeIpBar'
    
    this.$copy = this.$parent.querySelector('.as-copy')
    this.$continueBtn = this.$parent.querySelector('.as-continue-btn')
    this.$selectItem = this.$parent.querySelector('.as-select-item')
    this.$targetRegion = this.$parent.querySelector('.as-target-region')
    this.$closeBtn = this.$parent.querySelector('.as-close-bar')

    this.init()
  }
  init() {
    this.handleMetaData()
    this.initBarStatus()
  }
  handleMetaData() {
    // 初始化数据
    this.$data.areas = this.$zoneData && JSON.parse(this.$zoneData.innerHTML)
    this.$data.regions = this.$regionData && JSON.parse(this.$regionData.innerHTML)
    const initLocales = JSON.stringify(
      {
        locales: []
      }
    )
    this.$data.locales = JSON.parse((this.$localesData && JSON.parse(this.$localesData.innerHTML).find(item => item.configType === 1)?.content) || initLocales)?.locales
    this.$settings = this.$settingsData && JSON.parse(this.$settingsData.innerHTML).settings
    if (this.$path.length > 1) {
      this.$data.regions.map(item => {
        if (item.websiteUrl.endsWith('/')) {
          item.websiteUrl = item.websiteUrl + this.$path?.substring(1)
        } else {
          item.websiteUrl = item.websiteUrl + this.$path
        }
      })
    }
  }
  initBarStatus() {
    if (!this.$settings.enableIpGuide || this.getCookie(this.$closeBarCookie)) {
      this.$parent.remove()
      return
    }
    this.updateBar()
  }
  getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }
  updateBar() {
    this.getUserIp()
  }
  getUserIp() {
    let that = this
    this.ajax({
      url: '/browsing_context_suggestions.json',
      method: 'GET',
      done: function (response) {
        let userIp = response.detected_values && response.detected_values.country && response.detected_values.country.handle
        that.$userIp = userIp
        if(that.showBar(that.getReconmand(userIp))) {
          that.renderCopy()
          that.initStyle()
          that.listenResize()
          that.renderList()
          that.initBar()
        } else {
          return
        }
      }
    })
  }
  getReconmand(userIp) {
    // ip相同的
    let targetRegions = this.$data.regions.filter(item => item.isoCode === userIp)
    let defaultRegion = this.$data.regions.find(item => item.isRecommended)
    // 应该推荐哪个站点 
    targetRegions.length > 0 ? (this.$recommandRegionData = targetRegions[0]) : (defaultRegion && (this.$recommandRegionData = defaultRegion))
    return targetRegions
  }
  showBar(targetRegions) {
    try {
      let targetRegion = targetRegions && targetRegions.find(item => new URL(item.websiteUrl)?.host == this.$host)
      if (new URL(this.$recommandRegionData.websiteUrl).host === this.$host) return false
    }
    catch(err) {
    }
    return true
  }
  initStyle() {
    // TODO: 监听响应
    this.$parent.classList.remove('d-none')

    if (!this.$settings.enableSelector) {
      let dropdownBtn = document.querySelector('.as-dropdown-btn')
      dropdownBtn.classList.add('inactive')
    }

    let $regionList = document.querySelector('.as-region-list')
    this.$parent.style.backgroundColor = this.$settings.tipBarBg
    this.$parent.style.color = this.$settings.tipBarText
    this.$continueBtn.style.backgroundColor = this.$settings.tipBarBtnBg
    this.$continueBtn.style.borderColor = this.$settings.tipBarBtnBg
    this.$continueBtn.style.color = this.$settings.tipBarBtnText

    $regionList.style.backgroundColor = this.$settings.tipBarBg
  }
  listenResize() {
    this.initHeight()
    window.addEventListener('resize', this.debounce((event) => {
      this.initHeight()
    }, 500))
  }
  initHeight() {
    let height = this.$parent.offsetHeight
    document.body.style.paddingTop = `${height}px`
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    }
  }
  renderCopy() {
    let targetLocale = this.$data.locales.find(item => item.isoCode == this.$recommandRegionData.languageIsoCode)
    targetLocale?.tipText && (this.$copy.textContent = targetLocale?.tipText)
    targetLocale?.btnText && (this.$continueBtn.textContent = targetLocale?.btnText)
    targetLocale?.selectText && (this.$selectItem.textContent = targetLocale?.selectText)
  }
  renderList() {
    let recommands = this.$parent.querySelectorAll('.as-recommand-region')
    recommands.forEach(item => {
      item.textContent = this.$recommandRegionData.localName || this.$recommandRegionData.name
      if (item.classList.contains('as-option')) {
        item.dataset.url = this.$recommandRegionData.websiteUrl
      }
    })
    this.$continueBtn.href = this.$recommandRegionData.websiteUrl

    let $regionList = this.$parent.querySelector('.as-region-list')
    if (this.$settings.enableSelector) {
      if (this.$settings.selectorDropdown) {  
        // 渲染列表样式
        $regionList.removeChild($regionList.querySelector('.as-modal-select'))
        let $listHtmlTemplate = this.$parent.querySelector('.as-region-list-template')
        this.$data.regions.sort(this.sortData('region'))
        this.$data.regions.map(item => {
          if (item.isoCode != this.$recommandRegionData.isoCode) {
            let $newNode = document.createElement('li')
            let $listHtml = $listHtmlTemplate.innerHTML
            let $newHtml = $listHtml.replace('#{url}', item.websiteUrl).replace('#{region}', item.localName || item.name)
            $newNode.innerHTML = $newHtml
            $regionList.appendChild($newNode)
          }  
        })
      }
    }
  }
  initBar() {
    if (this.$settings.enableSelector) {
      let $regionLists = this.$parent.querySelectorAll('.as-region-item')
      $regionLists && $regionLists.forEach(item => {
        item.addEventListener('click', () => {
          let option = item.querySelector('.as-option')
          $regionLists.forEach(list => {
            list.classList.remove('selected')
          })
          item.classList.add('selected')
          this.$targetRegion.textContent = option.innerHTML
          if (option.dataset.style === "modal") {
            this.$continueBtn.dataset.bsToggle = 'modal'
            this.$continueBtn.dataset.bsTarget="#regionSelectorModal"
            this.$continueBtn.href="#"
          } else {
            delete this.$continueBtn.dataset.bsToggle
            delete this.$continueBtn.dataset.bsTarget
            this.$continueBtn.href = option.dataset.url
          }   
        })
      })
    }
    this.$closeBtn && this.$closeBtn.addEventListener('click', () => {
      this.$parent.remove()
      document.body.style.paddingTop = `0px`
      if (document.domain.split('.').slice(-2).join('.') !== 'myshopify.com') {
        document.cookie=`${this.$closeBarCookie}=true;path=/;domain=${document.domain.split('.').slice(-2).join('.')}`
      } else {
        document.cookie=`${this.$closeBarCookie}=true;path=/`
      } 
    })
  }
  sortData(property) {
    return function (a, b) {
      if (a[property] > b[property]) {
        return 1
      }
      if (a[property] < b[property]) {
        return -1
      }
      return 0
    }
  }

  ajax(options) {
    var xhr = new XMLHttpRequest()
    xhr.open(options.method, options.url)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
    xhr.setRequestHeader('Accept', 'application/json, text/javascript, */*')
    xhr.withCredentials = true
    xhr.onload = function () {
      if (xhr.status === 200 && xhr.responseText) {
        var response = JSON.parse(xhr.responseText)
        if (!response.error) {
          if (typeof options.done === 'function') options.done(response)
        } else if (response.error) {
          if (typeof options.fail === 'function') options.fail(response)
        }
      } else if (xhr.responseText) {
        var response = JSON.parse(xhr.responseText)
        if (typeof options.fail === 'function') options.fail(response)
      }
    }
    xhr.addEventListener("progress", function(event){
      if (event.lengthComputable) {
        var percentComplete = event.loaded / event.total
      }
    }, false)
    xhr.send()
  }
}
new IpGuide()
